import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, " Check your email inbox ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Enter the code that was emailed to you. ", -1)
const _hoisted_3 = { class: "text-center q-my-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_message = _resolveComponent("message")!
  const _component_async_btn = _resolveComponent("async-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitCode && _ctx.submitCode(...args)), ["prevent"]))
    }, [
      _createVNode(_component_q_input, {
        modelValue: _ctx.code,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event)),
        outlined: "",
        autofocus: ""
      }, null, 8, ["modelValue"]),
      (_ctx.result.error)
        ? (_openBlock(), _createBlock(_component_message, {
            key: 0,
            type: "negative",
            class: "q-mt-md"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.result.error), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_async_btn, {
          task: _ctx.task,
          type: "submit",
          label: "Continue",
          color: "primary",
          class: "full-width",
          rounded: ""
        }, null, 8, ["task"])
      ])
    ], 32)
  ]))
}